import React from 'react'
import ReactDOM from 'react-dom'
import {applyMiddleware, compose, createStore} from "redux"
import {Provider} from 'react-redux'
import 'antd/dist/antd.min.css'
import './statics/assets/css/libs/themify-icons.css';
import './statics/assets/css/libs/ionicons.min.css';
import './statics/assets/css/libs/material-icons.css';
import './statics/assets/css/libs/font-awesome.css';
import './statics/assets/css/libs/font-family.css';
import './scss/app.scss'
import App from './app/App'
import Router from "react-router-dom/Router"
import getHistory from "./store/getHistory"
import reducer from "./store/reducer"
import * as Sentry from "@sentry/react";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(reducer, composeEnhancers(applyMiddleware()));

if (import.meta.env.MODE === 'production') {
    Sentry.init({
        dsn: "https://e644e1f6438ed6eac3321a38b488e96f@crm.alohub.vn:9911/6",
        integrations: [
            Sentry.replayIntegration(),
        ],
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
    });
}

ReactDOM.render(
    (
        <Provider store={store}>
            <Router history={getHistory()}>
                <App/>
            </Router>
        </Provider>
    ),
    document.getElementById('root')
)
